import { Card, Tabs } from 'antd';
import { UserInfoForm } from '~/app/components/Profile/UserInfoForm';
import { SecurityForm } from '~/app/components/Profile/SecurityForm';
import type { CurrentUser } from '@evimo/types';
import { Language } from '@evimo/types/enums/language';

type ProfileProps = {
  user: CurrentUser | null;
  name: string;
  t: (key: string) => string;
  setName: (name: string) => void;
  language: Language;
  setLanguage: React.Dispatch<React.SetStateAction<Language>>;
  languageOptions: {
    label: string;
    value: Language;
  }[];
  saving: boolean;
  showOld: boolean;
  setShowOld: (show: boolean) => void;
  showNew: boolean;
  setShowNew: (show: boolean) => void;
  passwordError: { currentPassword?: string; newPassword?: string };
  setPasswordError: (err: {
    currentPassword?: string;
    newPassword?: string;
  }) => void;
  nameError: { name?: string; email?: string };
  setNameError: (err: { name?: string; email?: string }) => void;
  isNameFormDisabled: boolean;
  handleNameSave: () => void;
  passwordValues: { currentPassword: string; newPassword: string };
  setPasswordValues: (v: {
    currentPassword: string;
    newPassword: string;
  }) => void;
  isPasswordFormDisabled: boolean;
  handlePasswordFinish: (currentPassword: string, newPassword: string) => void;
};

export const Profile: React.FC<ProfileProps> = ({
  user,
  name,
  t,
  setName,
  language,
  setLanguage,
  languageOptions,
  saving,
  showOld,
  setShowOld,
  showNew,
  setShowNew,
  passwordError,
  nameError,
  isNameFormDisabled,
  handleNameSave,
  passwordValues,
  setPasswordValues,
  isPasswordFormDisabled,
  handlePasswordFinish,
}) => {
  return (
    <Card
      style={{
        width: '100%',
        maxWidth: '100%',
        margin: 0,
        boxSizing: 'border-box',
      }}
    >
      <Tabs
        defaultActiveKey="user_info"
        items={[
          {
            key: 'user_info',
            label: t('userAccount:labels.userInfo'),
            children: (
              <UserInfoForm
                user={user}
                name={name}
                setName={setName}
                language={language}
                setLanguage={setLanguage}
                languageOptions={languageOptions}
                t={t}
                saving={saving}
                nameError={nameError}
                isNameFormDisabled={isNameFormDisabled}
                handleNameSave={handleNameSave}
              />
            ),
          },
          {
            key: 'security',
            label: t('userAccount:labels.security'),
            children: (
              <SecurityForm
                t={t}
                showOld={showOld}
                setShowOld={setShowOld}
                showNew={showNew}
                setShowNew={setShowNew}
                passwordError={passwordError}
                passwordValues={passwordValues}
                setPasswordValues={setPasswordValues}
                isPasswordFormDisabled={isPasswordFormDisabled}
                handlePasswordFinish={handlePasswordFinish}
              />
            ),
          },
        ]}
      />
    </Card>
  );
};
